import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import {
  LbuSaleCoachingParams,
  LbuSaleCoachingListResult,
  LbuSaleCoachingEditParams,
  LbuSaleCoachingReviewParams,
  LbuSaleCoachingCommentParams
} from '@/typings/api/saleCoaching'

/**
 * ************************************** 销售业绩辅导 **************************************
 */
//  获取销售业绩辅导列表数据
export function saleCoachingList(data?: LbuSaleCoachingParams) {
  return request.post<LbuSaleCoachingListResult>('/lbu/api/salesCoaching/page', data)
}

export function saleCoachingCreate(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesCoaching/create', data)
}

export function saleCoachingUpdate(data: LbuSaleCoachingEditParams) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesCoaching/update', data)
}

export function saleCoachingReview(data: LbuSaleCoachingReviewParams) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesCoaching/review', data)
}

export function saleCoachingCommentCreate(data: LbuSaleCoachingCommentParams) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesCoaching/comment/create', data)
}

export function saleCoachingCommentDelete(data: {id?: string}) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesCoaching/comment/delete', data)
}

export function saleCoachingConfirm(data: {id?: string}) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesCoaching/confirm', data)
}

export function saleCoachingDelete(data: {id?: string}) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesCoaching/delete', data)
}

export function saleCoachingDetail(data: {id?: string}) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesCoaching/detail', data)
}
